/* eslint-disable @next/next/no-img-element */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import {
  EuiBreadcrumb,
  EuiHeader,
  EuiHeaderSectionItemButton,
  EuiText,
  EuiPopover,
  EuiContextMenuPanel,
  EuiContextMenuItem,
} from '@elastic/eui';
import { useRouter } from 'next/router';
import { FunctionComponent, useEffect, useState } from 'react';
import Link from 'next/link';

export type Props = {
  breadcrumb?: EuiBreadcrumb[];
};

export const HeaderSecondary: FunctionComponent<Props> = ({ breadcrumb }) => {
  const router = useRouter();
  const [crumbs, setCrumbs] = useState<EuiBreadcrumb[]>([]); // default to []

  useEffect(() => {
    const base: EuiBreadcrumb[] = [];
    setCrumbs(breadcrumb ? base.concat(breadcrumb) : base);
  }, [breadcrumb, router]);

  const [isPhonebookMenuOpen, setIsPhonebookMenuOpen] = useState(false);
  const [isSendMenuOpen, setIsSendMenuOpen] = useState(false);

  const phonebookButton = (
    <EuiHeaderSectionItemButton
      onClick={() => setIsPhonebookMenuOpen(!isPhonebookMenuOpen)}>
      <EuiText color="default" size="s">
        Phonebooks
      </EuiText>
    </EuiHeaderSectionItemButton>
  );

  const sendButton = (
    <EuiHeaderSectionItemButton
      onClick={() => setIsSendMenuOpen(!isSendMenuOpen)}>
      <EuiText color="default" size="s">
        Send
      </EuiText>
    </EuiHeaderSectionItemButton>
  );

  const phonebookMenuItems = (
    <EuiContextMenuPanel
      size="s"
      items={[
        <EuiContextMenuItem
          key="manage"
          onClick={() => {
            setIsPhonebookMenuOpen(false);
            router.push('/phonebook');
          }}>
          Manage Lists
        </EuiContextMenuItem>,
        <EuiContextMenuItem
          key="upload"
          onClick={() => {
            setIsPhonebookMenuOpen(false);
            router.push('/phonebook/upload');
          }}>
          Upload CSV
        </EuiContextMenuItem>,
        <EuiContextMenuItem
          key="search"
          onClick={() => {
            setIsPhonebookMenuOpen(false);
            router.push('/phonebook/search');
          }}>
          Search Contact
        </EuiContextMenuItem>,
        <EuiContextMenuItem
          key="add"
          onClick={() => {
            setIsPhonebookMenuOpen(false);
            router.push('/phonebook/add');
          }}>
          Add Number
        </EuiContextMenuItem>,
        <EuiContextMenuItem
          key="admin"
          onClick={() => {
            setIsPhonebookMenuOpen(false);
            router.push('/phonebook/admin');
          }}>
          Admin View
        </EuiContextMenuItem>,
      ]}
    />
  );

  const sendMenuItems = (
    <EuiContextMenuPanel
      size="s"
      items={[
        <EuiContextMenuItem
          key="bulk"
          onClick={() => {
            setIsSendMenuOpen(false);
            router.push('/send/bulk');
          }}>
          Bulk Send
        </EuiContextMenuItem>,
        <EuiContextMenuItem
          key="individual"
          onClick={() => {
            setIsSendMenuOpen(false);
            router.push('/send/individual');
          }}>
          Individual Send
        </EuiContextMenuItem>,
        <EuiContextMenuItem
          key="sends"
          onClick={() => {
            setIsSendMenuOpen(false);
            router.push('/send/sends');
          }}>
          Sends
        </EuiContextMenuItem>,
      ]}
    />
  );

  return (
    <EuiHeader
      position="fixed"
      sections={[
        {
          breadcrumbs: crumbs,
          breadcrumbProps: { responsive: false },
        },
        {
          items: [
            <EuiPopover
              key="phonebook-popover"
              id="phonebookPopover"
              button={phonebookButton}
              isOpen={isPhonebookMenuOpen}
              closePopover={() => setIsPhonebookMenuOpen(false)}
              panelPaddingSize="none"
              anchorPosition="downLeft">
              {phonebookMenuItems}
            </EuiPopover>,

            <EuiPopover
              key="send-popover"
              id="sendPopover"
              button={sendButton}
              isOpen={isSendMenuOpen}
              closePopover={() => setIsSendMenuOpen(false)}
              panelPaddingSize="none"
              anchorPosition="downLeft">
              {sendMenuItems}
            </EuiPopover>,

            <Link key="blocklist" href="/blocklist" passHref legacyBehavior>
              <EuiHeaderSectionItemButton>
                <EuiText color="default" size="s">
                  Blocklist
                </EuiText>
              </EuiHeaderSectionItemButton>
            </Link>,

            <Link key="reports" href="/reports" passHref legacyBehavior>
              <EuiHeaderSectionItemButton>
                <EuiText color="default" size="s">
                  Reports
                </EuiText>
              </EuiHeaderSectionItemButton>
            </Link>,

            <Link key="replies" href="/replies" passHref legacyBehavior>
              <EuiHeaderSectionItemButton>
                <EuiText color="default" size="s">
                  Replies
                </EuiText>
              </EuiHeaderSectionItemButton>
            </Link>,
          ],
        },
      ]}
    />
  );
};
